import fetch from 'isomorphic-fetch';
import { url } from '@ts/utils/url';

type Discussion = {
  allowed: boolean;
  message: string;
};

type UserInfo = {
  joinCommunity: boolean;
  isModeratedUser: boolean;
  isActiveUser: boolean;
  canSeeComments: boolean;
};

export class CommentsService {
  constructor(private readonly baseUrl: string = url.getBaseUrl()) {}

  getDiscussionStatus = async () => {
    const requestUrl = `${this.baseUrl}/@discussion`;

    const settings: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    };

    const response = await fetch(requestUrl, settings);

    if (!response.ok) {
      const msg = await response.text();
      throw new Error(`Status code:${response.status}\nError:${msg}`);
    }

    const res: Discussion = await response.json();

    return res;
  };

  getUserInfo = async () => {
    const requestUrl = `${this.baseUrl}/@discussion-user-info`;

    const settings: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    };

    const response = await fetch(requestUrl, settings);

    if (!response.ok) {
      const msg = await response.text();
      throw new Error(`Status code:${response.status}\nError:${msg}`);
    }

    const res: UserInfo = await response.json();

    return res;
  };

  getComments = async () => {
    const url = `${this.baseUrl}/@@comments`;

    const settings: RequestInit = {
      method: 'POST',
      headers: {
        Accept: 'text/html',
      },
    };

    const response = await fetch(url, settings);

    const res = await response.text();

    if (!response.ok) {
      throw new Error(`Status code:${response.status}\nError:${res}`);
    }

    return res;
  };

  getReplyForm = async (urlParams: string) => {
    const url = `${this.baseUrl}/reply-to-comment`;
    const queryParams = new URLSearchParams(`${urlParams}&ajax_load=1`);

    const formData = Object.fromEntries(queryParams.entries());

    const formDataDTO = new FormData();

    Object.entries(formData).forEach(([key, value]) => {
      formDataDTO.append(key, value.toString());
    });

    const settings: RequestInit = {
      method: 'POST',
      headers: {
        Accept: 'text/html',
      },
      body: formDataDTO,
    };

    const response = await fetch(url, settings);

    const res = await response.text();

    if (!response.ok) {
      throw new Error(`Status code:${response.status}\nError:${res}`);
    }

    return res;
  };
}
